// src/kantData2.js
const data = {
  name: "مقولات و صور منطقی در کانت",
  children: [
    {
      name: "منشأ مقولات",
      children: [
        {
          name: "عادت‌های عقلی (Alsted)",
          children: [
            { name: "تنظیم ذهن برای امکان معرفت" },
            { name: "هر عادت متناظر با یک عمل ذهنی" },
            {
              name: "ساده یا مختلط",
              children: [
                { name: "عادت‌های ساده حقیقی" },
                { name: "عادت‌های طبیعی ضروری و حقیقی" },
              ],
            },
          ],
        },
        {
          name: "مفاهیم ذاتی و اکتسابی",
          children: [
            { name: "کانت مخالف مفاهیم ذاتی" },
            { name: "ما هرچه داریم را اکتساب می‌کنیم (notiones acquisitae)" },
            { name: "فاهمه مفاهیم را هنگام تمرین اکتساب می‌کند" },
            { name: "کانت در «نقد عقل محض» اجازه بازنمودهای ذاتی را نمی‌دهد" },
            {
              name: "تمام بازنمودها به طور کلی اکتسابی هستند",
              children: [{ name: "اکتساب اصلی (ursprüngliche Erwerbung)" }],
            },
          ],
        },
        {
          name: "اپوژنزیس (epigenesis)",
          children: [
            { name: "منشأ امکان شهود حسی" },
            { name: "مکان به خودی خود بازنمود اکتساب اصلی" },
            { name: "مقولات مفاهیم اکتساب اصلی" },
            { name: "پیش‌فرض شرایط سوبژکتیو خودانگیختگی تفکر" },
            { name: "سیستم عام پیش‌شکل‌گیری (در مقابل پیش‌شکل‌گیری فردی)" },
            { name: "نوع ضعیف پیش‌شکل‌گیری" },
            { name: "سازگار با زبان پیش‌شکل‌گرایی در ویرایش اول «نقد»" },
            { name: "نظام اپوژنتیک عقل محض در § 27 ویرایش دوم" },
            { name: "کاربرد اصطلاحات زیستی در معرفت‌شناسی کانت" },
            {
              name: "مفاهیم یا ادکت (educta) یا محصول (producta)",
              children: [
                { name: "ادکت: پیش‌شکل‌گرایی" },
                { name: "محصول: اپوژنزیس (مورد تأیید کانت)" },
              ],
            },
            {
              name: "محصول یا از تأثیر فیزیکی تجربی یا از آگاهی ساختار صوری حساسیت و فاهمه (پیشینی)",
            },
            { name: "ایده‌های ذاتی از عرفان بر می‌آیند" },
            {
              name: "ایده‌های اکتسابی می‌توانند محصول اپوژنزیس باشند (پیشینی یا پسینی)",
            },
            {
              name: "بررسی ذهن در مورد ایده‌های اکتسابی می‌تواند فیزیولوژیکی یا انتقادی باشد",
              children: [
                {
                  name: "نقد: مربوط به خلوص پیشینی قوه شناختی و تمایز حساسیت و فاهمه",
                },
                { name: "فیزیولوژی: مربوط به منشأ پسینی مفاهیم" },
              ],
            },
          ],
        },
        {
          name: "تمایز ماده و صورت شناخت",
          children: [
            { name: "معرفی شده در منطق قوا (رساله افتتاحیه)" },
            { name: "مسائل اصلی در دوره انتقادی" },
            {
              name: "ظاهر شدن در نقاط مهم («ملاحظات عمومی در زیبایی‌شناسی استعلایی»، «مقدمه: ایده منطق استعلایی»)",
            },
            { name: "ماده: محتوای پسینی شناخت داده شده توسط حس" },
            {
              name: "صورت: ساختار محض و پیشینی ذهن که از طریق آن شناخت ابژه ممکن است",
            },
          ],
        },
        {
          name: "صور شناخت و منطق",
          children: [
            { name: "معرفت صورت: آگاهی به عنوان شرط" },
            {
              name: "صورت یا شهود یا مفهوم",
              children: [{ name: "شناخت صوری (formaliter cognitio)" }],
            },
            { name: "شکستن پیوستگی در سنت لایب نیتس" },
            { name: "تفاوت حقیقی بین صور معرفت حسی و معقول" },
            { name: "این تمایز اساس امکان ایده‌آلیسم استعلایی کانت" },
            { name: "صورت معرفت معقول به عنوان مفهوم: تفکر حقیقی" },
            { name: "منطق عمومی: مربوط به تفکر" },
            { name: "منطق فقط با صور و نه محتوا سروکار دارد (Zabarella)" },
          ],
        },
        {
          name: "زمان و مکان",
          children: [
            { name: "یگانه صور شناخت در زیبایی‌شناسی استعلایی" },
            { name: "تحت تأثیر دیدگاه اویلر (نیوتنی) و لایب‌نیتس" },
            { name: "لایب‌نیتس: زمان و مکان modi considerandi یک ابژه هستند" },
            { name: "معرفت پدیداری از ابژه می‌دهند" },
            {
              name: "دکترین زمان و مکان به عنوان صور محض حساسیت اصالتاً کانتی نیست",
            },
            { name: "ماتریس لایب‌نیتی با تفاوت‌هایی" },
            {
              name: "لایب‌نیتس حرکت را نیز به عنوان modi considerandi حساسیت اضافه می‌کند",
            },
            {
              name: "کانت مخالف است: مفهوم حرکت فقط از طریق و در بازنمود زمان ممکن است",
            },
          ],
        },
        {
          name: "سیلوجیسم ارسطویی",
          children: [
            { name: "انواع سیلوجیسم صحیح بر اساس اعتبار و قطعیت مقدمات" },
            { name: "مقدمات صحیح و قطعی: برهان" },
            { name: "مقدمات محتمل: استدلال دیالکتیکی" },
            { name: "مقدمات کاذب یا فریبنده: استنتاج بلاغی" },
            { name: "مبتنی بر سه اصل (اسکولاستیک‌ها چهارم را اضافه کردند)" },
            { name: "اصل عدم تناقض" },
            { name: "اصل حمل بر کل و حمل بر عدم (dictum de omni et nullo)" },
          ],
        },
        {
          name: "دیالکتیک در کانت",
          children: [
            { name: "منطق ex probabilibus و ex apparentibus" },
            { name: "قضاوت منفی به عنوان منطق وهم" },
            { name: "نقد فاهمه و عقل در کاربرد فراطبیعی" },
            { name: "مفهوم دیالکتیک در معنای شکاکانه (کاتارتیک)" },
            { name: "بهترین وسیله تطهیر عقل" },
            { name: "مسیر به سوی حقیقت آنچه بررسی می‌شود" },
          ],
        },
        {
          name: "مقولات آزادی (عملی)",
          children: [
            { name: "مفاهیم عملی محض و اساسی" },
            { name: "مربوط به کاربرد آزادی (قواعد عملی یا اوامر)" },
            { name: "آزادی نوعی علیت مبتنی بر قواعد" },
            {
              name: "بررسی اعمال و قواعد عملی از دو دیدگاه",
              children: [
                {
                  name: "شرح علّی توصیفی (ویژگی‌های پدیداری)",
                  children: [
                    { name: "توضیح با قوانین علّی مرتبط کننده پدیدارها" },
                  ],
                },
                {
                  name: "ارزیابی اخلاقی (محصول آزادی عامل)",
                  children: [{ name: "ارزیابی بر اساس مفاهیم خوب و بد" }],
                },
              ],
            },
            {
              name: "فقط مقولات جهت باید اخلاقاً معین شوند؟ (تفسیر جایگزین)",
              children: [
                {
                  name: "پیامد: کمیت، کیفیت و رابطه اصول اخلاقی مشروط حسی خواهند بود (نمی‌تواند درست باشد)",
                },
              ],
            },
            {
              name: "تأیید تفسیر پیشنهادی",
              children: [
                {
                  name: "مقولات سوم مشروط حسی نیستند و توسط قانون اخلاقی تعیین می‌شوند",
                },
                {
                  name: "فقط مقولات سوم هر سرشاخه دربرگیرنده اصل اخلاقی هستند",
                },
                { name: "تمام اصول اخلاقی ویژگی‌های مقولات سوم را دارند" },
                { name: "تمام اصول غیر اخلاقی فاقد آن ویژگی‌ها هستند" },
              ],
            },
          ],
        },
        {
          name: "قواعد عملی کمیسیون و omission",
          children: [
            { name: "استثناها: ترکیب کمیسیون‌ها و omission‌ها" },
            { name: "قواعد کمیسیون و omission مشروط حسی هستند" },
            {
              name: "کمیسیون: وابسته به قوه میل (جستجوی آنچه مطبوع و رفاه را ترویج می‌کند)",
            },
            {
              name: "omission: وابسته به قوه انزجار (اجتناب از آنچه نامطبوع و منجر به بدی است)",
            },
            { name: "خوب و بد: مربوط به قواعد استثناها" },
            {
              name: "قواعد اخلاقی مشروط حسی نیستند",
              children: [
                { name: "فقط قواعد اخلاقی می‌توانند قواعد استثناها باشند" },
                { name: "فقط قانون اخلاقی می‌تواند سایر قواعد را باطل کند" },
                { name: "فقط امر مطلق می‌تواند امرهای شرطی را رد کند" },
              ],
            },
            {
              name: "وقوع استثناء واقعی: زمانی که قواعد اخلاقی و مبتنی بر میل با هم تضاد دارند",
            },
            {
              name: "در تضاد امور شرطی: تغییر اهداف و ایجاد قاعده جدید (اهداف بر هم غلبه می‌کنند نه قواعد)",
            },
            { name: "قواعد استثنائات مشروط حسی وجود ندارند" },
          ],
        },
      ],
    },
    {
      name: "منطق استعلایی و عمومی",
      children: [
        { name: "تمایز ضروری" },
        { name: "وظیفه منطق استعلایی" },
        { name: "ساختار منطق عمومی" },
        { name: "ساختار متناظر در منطق استعلایی" },
      ],
    },
    {
      name: "تمایز مقولات کانت",
      children: [
        { name: "نقطه شروع: منطق ارسطویی" },
        { name: "لحظات حکم (وجه‌ها)" },
        { name: "مفاهیم متناظر فاهمه" },
        { name: "مشتق شده از انواع حکم" },
      ],
    },
    {
      name: "جدول مقولات کانت",
      children: [
        {
          name: "کمیت",
          children: [{ name: "وحدت" }, { name: "کثرت" }, { name: "کلیّت" }],
        },
        {
          name: "کیفیت",
          children: [{ name: "واقعیت" }, { name: "سلب" }, { name: "حدّ" }],
        },
        {
          name: "رابطه",
          children: [
            { name: "جوهر و عرض" },
            { name: "علیت و وابستگی" },
            { name: "جامعه" },
          ],
        },
        {
          name: "جهت",
          children: [
            { name: "امکان–عدم امکان" },
            { name: "وجود–عدم وجود" },
            { name: "ضرورت–مقارنه" },
          ],
        },
        { name: "کامل بودن و نظام‌مند بودن" },
        { name: "توجه به صورت محض فاهمه" },
      ],
    },
    {
      name: "قیاس مابعدالطبیعی",
      children: [
        {
          name: "اشتقاق جدول مقولات از جدول احکام",
          children: [
            { name: "انتزاع از تمام محتوای حکم" },
            { name: "عملکرد تفکر ذیل چهار عنوان" },
            { name: "هر عنوان شامل سه لحظه" },
          ],
        },
        { name: "برتری مقولات کانت" },
        { name: "کشف نظام‌مند همه مفاهیم محض فاهمه" },
      ],
    },
    {
      name: "ارتباط با ارسطو",
      children: [
        { name: "استفاده از آموزه‌های ارسطویی" },
        { name: "مخالفت با نتیجه‌گیری‌ها" },
        { name: "سنت ارسطویی در کونیگسبرگ" },
        {
          name: "منطق قوا در ارسطو (پسین‌تحلیلات II.19)",
          children: [
            { name: "قلمرو فلسفی که اندیشه کانت را پرورش داد" },
            { name: "نیروی متمایزکننده ذاتی (حس)" },
            { name: "بقای محسوسات در ذهن" },
            { name: "منشأ حافظه و تجربه" },
            { name: "تشکیل مفهوم کلی (katholou)" },
            { name: "فرآیند استقرا (epagoge)" },
            { name: "فرآیند تعقل (noein)" },
            { name: "دو وجه اکتساب مفاهیم و اصول کلی" },
            { name: "معرفت غیر علمی در ابتدا" },
            { name: "اثبات با برهان برای معرفت علمی" },
          ],
        },
      ],
    },
    {
      name: "مابعدالطبیعه کانت",
      children: [
        {
          name: "فلسفه اصول اولیه فاهمه محض",
          children: [
            {
              name: "نولوژیا (در سنت ارسطویی کونیگسبرگ)",
              children: [
                { name: "بخشی از مابعدالطبیعه" },
                { name: "بخش مقدماتی برای بنیان‌گذاری تفکر مابعدالطبیعی" },
              ],
            },
            {
              name: "هستی‌شناسی (در «چه پیشرفت واقعی...»)",
              children: [
                { name: "بخشی از مابعدالطبیعه" },
                { name: "نقش مقدماتی" },
                { name: "سالن انتظار مابعدالطبیعه" },
              ],
            },
            {
              name: "اصول اولیه استفاده از فاهمه محض",
              children: [
                { name: "بخشی از فلسفه استعلایی" },
                { name: "شامل شرایط و عناصر اولیه معرفت پیشینی" },
                { name: "حل معرفت به مفاهیم پیشینی در فاهمه" },
                { name: "استفاده در تجربه (تحلیلی در نقد عقل محض)" },
              ],
            },
          ],
        },
      ],
    },
    {
      name: "ساختار نقد عقل محض",
      children: [
        {
          name: "نقد",
          children: [
            { name: "عدم پیشرفت زیاد از زمان ارسطو" },
            { name: "نولوژیا" },
            { name: "بخشی از هستی‌شناسی (در سنت ارسطویی کونیگسبرگ)" },
            { name: "فلسفه عقل محض" },
            { name: "بررسی مقدماتی قوه عقل در معرفت پیشینی ممکن" },
            { name: "شامل تمام اصول معرفت پیشینی (حسی و معقول)" },
            { name: "نقش منفی: نه برای بسط، بلکه برای تطهیر عقل" },
          ],
        },
        {
          name: "ارگانون عقل محض",
          children: [
            { name: "مجموع اصول برای اکتساب و تحقق معرفت محض پیشینی" },
            { name: "کاربرد جامع ارگانون" },
          ],
        },
        {
          name: "نظام عقل محض",
          children: [
            {
              name: "چهار بخش اصلی (پیروی از ولف)",
              children: [
                { name: "هستی‌شناسی (فلسفه استعلایی)" },
                { name: "فیزیولوژی عقلی" },
                { name: "کیهان‌شناسی عقلی" },
                { name: "الهیات عقلی" },
              ],
            },
          ],
        },
      ],
    },
    {
      name: "نقد عقل محض کانت",
      children: [
        { name: "نقطه عطفی در فلسفه غرب" },
        { name: "تأثیر اجتناب‌ناپذیر بر فلسفه بعد از آن" },
        {
          name: "سه هدف اصلی",
          children: [
            { name: "1. نظریه جدید معرفت" },
            { name: "2. نقد ویرانگر مابعدالطبیعه نظری سنتی" },
            {
              name: "3. توجیه باورهای اصلی سنت مابعدالطبیعی غربی",
              children: [
                { name: "قطعیت در مورد اصول بنیادی تجربه انسانی" },
                { name: "هزینه: معرفت به چگونگی اشیا به خودی خود" },
                { name: "مبتنی بر نظریه جدید معرفت" },
                { name: "باورهایی که به عنوان معرفت نظری قابل توجیه نیستند" },
                { name: "توجیه به عنوان موضوعات «ایمان اخلاقی»" },
                {
                  name: "شرایط لازم برای امکان کنشگری اخلاقی",
                  children: [
                    { name: "ایدئال‌های نامشروط عقل" },
                    {
                      name: "قانون اخلاقی معتبر مطلق (در Canon of Pure Reason)",
                    },
                  ],
                },
                {
                  name: "شرایط لازم برای امکان تلاش منطقی برای تحقق قانون اخلاقی",
                  children: [
                    { name: "وجود آزادی" },
                    { name: "جاودانگی" },
                    { name: "خدا" },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      name: "توسعه اندیشه کانت در دهه سکوت",
      children: [
        { name: "پس از انتشار رساله افتتاحیه (1770)" },
        { name: "تقریباً هیچ چیز منتشر نکرد تا یک دهه" },
        { name: "تخصیص کامل خود به آماده‌سازی اثر بزرگش" },
      ],
    },
    {
      name: "وهم‌های طبیعی و اجتناب‌ناپذیر",
      children: [
        { name: "مشابه وهم بزرگتر دیده شدن ماه هنگام طلوع" },
        { name: "ناشی از تمایل اجتناب‌ناپذیر به اشتباه گرفتن وظیفه عقل" },
        { name: "وظیفه عقل: جستجوی نامشروط برای معرفت‌های مشروط" },
        {
          name: "اشتباه: فرض اینکه با مشروط، کل سلسله شرایط داده شده است (که خود نامشروط است)",
        },
      ],
    },
    {
      name: "فایده مثبت عقل محض",
      children: [
        { name: "نباید فقط منبع مغالطات نظری باشد" },
        {
          name: "دو وجه فایده مثبت",
          children: [{ name: "باورهای عملی" }, { name: "باورهای اخلاقی" }],
        },
        {
          name: "نام‌گذاری در نقد عقل محض:",
          children: [{ name: "کاربرد صرفاً ذاتی (immanent)" }],
        },
        {
          name: "نام‌گذاری در نقد عقل عملی و آثار بعدی:",
          children: [{ name: "مسائل اخلاقی" }],
        },
      ],
    },
    {
      name: "کوپرنیکی کانت",
      children: [
        {
          name: "اشیاء معرفت پیشینی ذاتی ما باید «توسط بازنمودهای ما ممکن شوند»",
          children: [
            { name: "اشیاء باید به عنوان پدیدارها در نظر گرفته شوند" },
            {
              name: "ساختاریافته توسط صورت‌های مشارکت داده شده توسط ذهن",
              children: [
                {
                  name: "زیبایی‌شناسی استعلایی:",
                  children: [{ name: "(1) صورت اشیا در مکان و زمان" }],
                },
                {
                  name: "مقولات:",
                  children: [{ name: "(2) وحدت ترکیبی کثیر در مفاهیم" }],
                },
              ],
            },
          ],
        },
        { name: "عدم تقارن عمدی در دو کاربرد مکانیسم کوپرنیکی" },
        {
          name: "اعتراض به استنتاج کانت در مورد مکان و زمان",
          children: [
            {
              name: "معرفت ضروریات از صورت مکانی-زمانی لزوماً به عدم مکانی-زمانی بودن اشیا به خودی خود منجر نمی‌شود",
            },
            {
              name: "معرفت لزوماً «با ابژه مطابق نیست» به معنای تولید صرف از رویارویی تجربی",
            },
            {
              name: "اما ممکن است به معنای دیگری با واقعیت مطابق باشد: صورت مکانی-زمانی ممکن است هم به پدیدارها و هم به اشیا به خودی خود اطلاق شود",
            },
            { name: "کانت بدون توجیه ظاهری «توافق-مطابقت» را انکار می‌کند" },
            {
              name: "امکان معقول: مکانی-زمانی بودن هم صورت پدیدار و هم واقعیت به خودی خود است",
            },
          ],
        },
      ],
    },
    {
      name: "معرفت پیشینی",
      children: [
        { name: "اصطلاح معرفت‌شناختی" },
        { name: "واجد قید برای افعال شناختی" },
        { name: "نشان‌دهنده روش تشکیل ادعاهای شناختی" },
        { name: "معرفت «مستقل از تمام تجربه و حتی از تمام انطباعات حواس»" },
        { name: "در مقابل معرفت تجربی (پسینی)" },
        { name: "مفهوم نسبتاً قوی «استقلال» از تجربه" },
        { name: "دانستن پیشاپیش (مثل سقوط خانه) لزوماً معرفت پیشینی نیست" },
        { name: "اصلی که از آن نتیجه می‌گیریم خود از تجربه شناخته شده است" },
      ],
    },
    {
      name: "قضایای تحلیلی و ترکیبی",
      children: [
        { name: "تمایز اساسی در مقدمه «نقد»" },
        {
          name: "تعریف کانت از تحلیلی (containment definition)",
          children: [
            {
              name: "محمول B به فاعل A تعلق دارد، به عنوان چیزی که در مفهوم A «مستتر» است",
            },
          ],
        },
        {
          name: "نقدها به تعریف مستتر بودن:",
          children: [
            { name: "ایده نامشخص است" },
            { name: "محدود به قضایای فاعل-محمولی" },
          ],
        },
        {
          name: "معیارهای دیگر تمایز تحلیلی از ترکیبی (در همان بخش)",
          children: [
            { name: "اندیشیده شده از طریق اینهمانی (یا تناقض)" },
            { name: "صرفاً توضیحی (explicative)" },
            { name: "نه توسعه‌دهنده (ampliative)" },
          ],
        },
        { name: "محمول B کاملاً خارج از مفهوم A قرار دارد (قضایای ترکیبی)" },
      ],
    },
    {
      name: "معرفت مابعدالطبیعی ترکیبی پیشینی",
      children: [
        {
          name: "امکان‌پذیر است، اما با محدودیت‌های بسیار محدود",
          children: [
            {
              name: "اصولی که امکان تجربه به طور کلی را توضیح و تضمین می‌کنند",
            },
            { name: "متقدم بر تجربه و قابل شناخت پیشینی" },
            {
              name: "مانند «هر رویداد علتی دارد»، «جوهر باقی می‌ماند و همیشه در تغییر حفظ می‌شود»",
            },
          ],
        },
        {
          name: "توجیه فقط به عنوان شرایط امکان تجربه",
          children: [
            { name: "منبع اطلاعاتی که «چیز سوم» را فراهم می‌کند" },
            {
              name: "دلیلی برای حمل ترکیبی یک مفهوم بر دیگری (حتی بدون رابطه مستتر بودن)",
            },
          ],
        },
        { name: "استناد به تجربه ممکن" },
        { name: "محدودیت قلمرو مشروع مابعدالطبیعه" },
        { name: "اصول فراتر از حدود تجربه ممکن اعتبار ندارند" },
      ],
    },
    {
      name: "هستی‌شناسی هوسرل",
      children: [
        {
          name: "تمایز مقولات معانی از مقولات ابژه‌های متناظر",
          children: [
            { name: "همبسته‌های مقولات معنایی متمایز توسط آزمون بی‌معنی بودن" },
          ],
        },
        {
          name: "ابتکار دوم: تمایز ماهیات صوری برتر از ماهیات مادی برتر",
          children: [
            { name: "ماهیات صوری برتر: «مقولات»" },
            { name: "ماهیات مادی برتر: «نواحی»" },
          ],
        },
        {
          name: "مقولات هستی‌شناختی صوری",
          children: [
            { name: "عالی‌ترین انواع صوری" },
            { name: "متمایز شده با فرآیند صورت‌پردازی (حذف محتوا)" },
          ],
        },
        {
          name: "ماهیات مقولی:",
          children: [
            { name: "شروع با «ابژه به طور کلی» در بالا" },
            {
              name: "تقسیم در سطح بعدی به مقولاتی شامل: ابژه، وضعیت امور، ویژگی، رابطه، عدد و غیره",
            },
          ],
        },
        {
          name: "تمایز در مقولات صوری:",
          children: [
            { name: "مقوله زیربنایی افراد (یا محض این-آن)" },
            { name: "ابژکتیوهای ترکیبی وابسته" },
          ],
        },
      ],
    },
    {
      name: "شکاکیت در مورد سیستم‌های مقولات",
      children: [
        { name: "سیستم‌های رئالیستی و توصیفی (سنتی)" },
        {
          name: "استدلال‌ها در مورد سیستم صحیح مقولات",
          children: [
            {
              name: "پیش‌فرض: یک پاسخ حقیقی منحصر به فرد به سؤال در مورد مقولات موجود",
            },
            { name: "هدف: کشف این پاسخ" },
          ],
        },
      ],
    },
    {
      name: "کاربرد تمایز مقولات در متافیزیک",
      children: [
        {
          name: "پیگیری ریشه‌یابی اشتباهات و سردرگمی‌ها در هستی‌شناسی",
          children: [
            { name: "پیش‌فرض: یک لیست مقولات منحصر به فرد و صحیح وجود دارد" },
            {
              name: "استفاده اشتباه از ادعاهای وجودی و کمّی خنثی نسبت به مقوله",
            },
            {
              name: "بسیاری از استدلال‌ها در هستی‌شناسی متکی بر ادعاهایی در مورد وجود «ابژه» (به روش خنثی نسبت به مقوله)",
            },
            { name: "اگر این درست باشد، چنین استدلال‌هایی گمراه کننده هستند" },
          ],
        },
        {
          name: "ادعاهای وجودی و کمّی باید تلویحاً مقوله‌ای از موجودیت را فرض بگیرند",
        },
        {
          name: "پذیرش این دیدگاه: ارائه مبنای یکنواخت برای حل تعدادی از مشکلات",
          children: [
            { name: "مشکلات مربوط به پذیرش هستی‌شناسی اشیاء عادی" },
            {
              name: "متکی بر اصول یا قضاوت‌های اشتباه در مورد مقولات هستی‌شناختی",
            },
            {
              name: "پاسخ صحیح: اصلاح اشتباهات در مورد مقولات، نه حذف موجودیت‌ها",
            },
          ],
        },
        {
          name: "استدلال‌های استاندارد برای حذف‌گرایی در مورد نوعی از موجودیت",
        },
        {
          name: "این تحلیل: ارائه نوعی حمایت غیرمستقیم از هستی‌شناسی‌های «اجازه‌گرا»",
          children: [
            {
              name: "پذیرش وجود اعداد، ویژگی‌ها، سوراخ‌ها و سایر موجودیت‌هایی که متافیزیسین‌ها غالباً سعی در اجتناب از تعهد به آنها داشته‌اند",
            },
          ],
        },
      ],
    },
    {
      name: "فلسفه استعلایی",
      children: [
        { name: "بخشی از مابعدالطبیعه" },
        { name: "شامل شرایط و اولین عناصر هر معرفت پیشینی" },
        {
          name: "حل معرفت به مفاهیمی که پیشینی در فاهمه نهفته‌اند و در تجربه کاربرد دارند",
        },
        { name: "آنچه کانت «تحلیلی» در نقد عقل محض می‌نامد" },
      ],
    },
    {
      name: "حساسیت و فاهمه",
      children: [
        { name: "تنها دو قوای ذاتی ذهن انسان" },
        { name: "ماده شناخت: محتوای پسینی داده شده توسط حس" },
        { name: "صورت شناخت: ساختار محض و پیشینی ذهن" },
        { name: "از قوه خود بر می‌آید (پیشینی)" },
        { name: "پذیرش صرف peculiar به ذهن" },
        { name: "ذاتی" },
      ],
    },
    {
      name: "دکترین کانت در مورد مقولات",
      children: [
        {
          name: "ناشی از شکست تلاش‌های پیش‌انتقادی برای یافتن اولین، ساده‌ترین و ابتدایی‌ترین مفاهیم",
        },
        { name: "شکست پروژه سیلوجیستی و ترکیبی" },
        { name: "مفاهیم صرفاً ابزارهای اکتشافی برای توضیح واقعیت هستند" },
        { name: "مفاهیم به هیچ وجه بلوک‌های سازنده واقعیت نیستند" },
        {
          name: "تحقیق منطقی نمی‌تواند از مفاهیم شروع شود، بلکه از احکامی که مفاهیم از آنها تعیین می‌شوند",
        },
        {
          name: "مقولات نه به عنوان بالاترین انواع یا مفاهیم اول، بلکه به عنوان modi considerandi و cognoscendi",
        },
        {
          name: "مقولات به عنوان modi considerandi: معنای معین به ابژه معرفت می‌دهند",
        },
        { name: "ردیابی به ارسطوگرایی اولیه مدرن (Zabarella و Pace)" },
        {
          name: "Schema (رقم فرآیند اسناد و ترتیب مقولات) نیز منشأ ارسطویی دارد",
        },
        { name: "شرط فکر و تجربه عمومی" },
      ],
    },
    {
      name: "انتزاع کل محتوای احکام ممکن",
      children: [
        { name: "یافتن منشأ توجیهی نقش منطق عمومی" },
        { name: "منبع معرفت عقلی" },
        { name: "جدول صور منطقی" },
        {
          name: "چهار وجه طبقه‌بندی حکم",
          children: [
            {
              name: "کمیت",
              children: [{ name: "کلی" }, { name: "جزئی" }, { name: "مفرد" }],
            },
            {
              name: "کیفیت",
              children: [
                { name: "تصدیقی" },
                { name: "سلبی" },
                { name: "نامتناهی" },
              ],
            },
            {
              name: "رابطه",
              children: [
                { name: "حملی" },
                { name: "شرطی" },
                { name: "منفصله" },
              ],
            },
            {
              name: "جهت",
              children: [
                { name: "امکانی" },
                { name: "اثباتی" },
                { name: "ضروری" },
              ],
            },
          ],
        },
        { name: "دوازده مفهوم محض فاهمه" },
        { name: "چهار طبقه سه تایی" },
      ],
    },
  ],
};
export default data;
